import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const LoadBalancer = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.75314 8.8909V10.8917"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.2541 8.8909V10.8917"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.7551 8.8909V10.8917"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.25299 14.8934V16.8942C9.25299 17.4467 9.7009 17.8946 10.2534 17.8946H14.2551C14.8076 17.8946 15.2555 17.4467 15.2555 16.8942V14.8934H16.7561C17.3086 14.8934 17.7565 14.4455 17.7565 13.893V9.89132C17.7565 9.3388 17.3086 8.8909 16.7561 8.8909H7.75237C7.19985 8.8909 6.75195 9.3388 6.75195 9.89132V13.893C6.75195 14.4455 7.19985 14.8934 7.75237 14.8934H9.25299Z"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <rect
            x="3.25"
            y="3.88882"
            width="18.0075"
            height="18.0075"
            rx="3"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </SVGIconRender>
  );
};

export default LoadBalancer;
